module.exports = require("mermaid");


//////////////////
// WEBPACK FOOTER
// external "mermaid"
// module id = 1
// module chunks = 0